// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main_settings_contract > .content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--gap_xmid);\n}\n.main_settings_contract > .content .btn_container {\n  align-self: flex-end;\n}\n.main_settings_contract .contracts_container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--gap);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
